import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { useIntl } from 'react-intl';
import _ from 'lodash';

import { APIgetRoles } from '../../../api/Roles';

import { getBuiltInRoles } from '../../../helpers/Users';

const AdminUsersFiltersSelected = ({
  userActivationStatuses,
  selectedUserActivationStatuses,
  selectedRoles,
  handleChangeFilter,
}) => {
  const intl = useIntl();
  const [rolesById, setRolesById] = useState({});

  const filteredSelectedFileStatuses = selectedUserActivationStatuses.filter(i => (i !== 'all'));
  const filteredSelectedRoles = selectedRoles.filter(i => (i !== 'all'));

  useEffect(() => {
    const fetchRoles = async () => {
      const builtInRoles = _.sortBy(
        getBuiltInRoles().map(role => ({
          id: `${role.value}`,
          name: role.label,
        })),
        'id',
      );

      const response = await APIgetRoles({ all: true });
      const customRoles = (response?.data || []).map(role => ({
        id: `${role.id}`,
        name: role.name,
      }));

      const mappedRoles = [...builtInRoles, ...customRoles].reduce((acc, role) => {
        acc[`${role.id}`] = role.name;
        return acc;
      }, {});

      setRolesById(mappedRoles);
    };

    fetchRoles();
  }, []);

  const isVisible = useMemo(
    () => (
      (Object.keys(userActivationStatuses).length > 0 && filteredSelectedFileStatuses.length > 0)
      || filteredSelectedRoles.length > 0
    ),
    [filteredSelectedFileStatuses.length, filteredSelectedRoles.length, userActivationStatuses],
  );

  return (
    <div className="filters-selected filters-selected-users">
      {isVisible && (
        <div className="tags-list">
          {filteredSelectedFileStatuses.map(statusId => (
            <div key={`selected-status-${statusId}`} className="tag">
              <span className="tag-label" title={`Status: ${userActivationStatuses[statusId]}`}>
                {userActivationStatuses[statusId]}
              </span>
              {/* eslint-disable jsx-a11y/click-events-have-key-events */}
              <span
                className="tag-remove"
                title="Remove"
                role="button"
                tabIndex={-1}
                onClick={() => {
                  handleChangeFilter({
                    target: {
                      name: 'selectedUserActivationStatuses',
                      value: statusId,
                      checked: false,
                      type: 'checkbox',
                    },
                  });
                }}
              >
                <i className="far fa-times" />
              </span>
              {/* eslint-enable jsx-a11y/click-events-have-key-events */}
            </div>
          ))}
          {filteredSelectedRoles.map(roleId => (
            <div key={`selected-role-${roleId}`} className="tag">
              <span className="tag-label" title={`Role: ${rolesById[roleId] || roleId}`}>
                {rolesById[roleId] || roleId}
              </span>
              {/* eslint-disable jsx-a11y/click-events-have-key-events */}
              <span
                className="tag-remove"
                title="Remove"
                role="button"
                tabIndex={-1}
                onClick={() => {
                  handleChangeFilter({
                    target: {
                      name: 'selectedRoles',
                      value: roleId,
                      checked: false,
                      type: 'checkbox',
                    },
                  });
                }}
              >
                <i className="far fa-times" />
              </span>
              {/* eslint-enable jsx-a11y/click-events-have-key-events */}
            </div>
          ))}
          <Button
            color="link"
            size="sm"
            onClick={() => {
              handleChangeFilter({
                target: {
                  name: 'selectedUserActivationStatuses',
                  value: null,
                  checked: true,
                  type: 'checkbox',
                },
              });

              handleChangeFilter({
                target: {
                  name: 'selectedRoles',
                  value: null,
                  checked: true,
                  type: 'checkbox',
                },
              });
            }}
          >
            {intl.formatMessage({ defaultMessage: 'Clear all' })}
          </Button>
        </div>
      )}
    </div>
  );
};

AdminUsersFiltersSelected.propTypes = {
  userActivationStatuses: PropTypes.object.isRequired,
  selectedUserActivationStatuses: PropTypes.array.isRequired,
  selectedRoles: PropTypes.array.isRequired,
  handleChangeFilter: PropTypes.func.isRequired,
};

export default AdminUsersFiltersSelected;
